import React, { FunctionComponent } from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { Wrapper, Icon, Text, Button } from "./styles/widget-error-styles";

interface IWidgetErrorProps {
  text: string;
  routerBackButton?: boolean;
  routerBackButtonLink?: string;
  buttonAction?: () => void;
  buttonName?: string;
}

const WidgetError: FunctionComponent<IWidgetErrorProps> = ({
  text,
  routerBackButton,
  routerBackButtonLink,
  buttonAction,
  buttonName,
}) => (
  <Wrapper>
    <Icon>
      <FontAwesomeIcon icon={faExclamationTriangle} />
    </Icon>
    <Text>{text}</Text>
    {routerBackButton && (
      <NavLink title="Go Back" to={routerBackButtonLink}>
        <Button type="button" onClick={buttonAction}>
          {buttonName}
        </Button>
      </NavLink>
    )}
  </Wrapper>
);

WidgetError.propTypes = {
  text: PropTypes.string.isRequired,
  routerBackButton: PropTypes.bool,
  routerBackButtonLink: PropTypes.string,
  buttonAction: PropTypes.func,
  buttonName: PropTypes.string,
};

WidgetError.defaultProps = {
  routerBackButton: null,
  routerBackButtonLink: null,
  buttonAction: null,
  buttonName: null,
};

export default WidgetError;
